module.exports = __webpack_public_path__ + "img/check.211863c1.svg";